import OtaListContainer from './OtaListContainer';

export default OtaListContainer;
